import React from "react";

// import Navbar from "react-bootstrap/Navbar";

function FormExample() {
  return (
    <div>
      <div className="flex"></div>
      <div className="ml-7 mt-6 flex gap-6 pl-6">
        <svg className="animate-bounce w-6 h-6 bg-black rounded-full"></svg>
        <svg className="animate-bounce w-6 h-6 bg-white rounded-full"></svg>
        <svg className="animate-bounce w-6 h-6 bg-black rounded-full"></svg>
        <svg className="animate-bounce w-6 h-6 bg-white rounded-full"></svg>
        <svg className="animate-bounce w-6 h-6 bg-black rounded-full"></svg>
        <svg className="animate-bounce w-6 h-6 bg-white rounded-full"></svg>
        <svg className="animate-bounce w-6 h-6 bg-black rounded-full"></svg>
      </div>
    </div>
  );
}

export default FormExample;
